import './_Styles/AlertToast.css';
import { useEffect, useState } from 'react';
import { onResolveAlertTemplate } from './_AlertTemplates';
import { ALERT_TEMPLATE_EVENT, ALERT_POSITION_EVENT, onReadAlertTemplate, onReadAlertPosition } from '../../AppTemplateResolved';

/*
    🔥 HOST DE ALERTS

    Monta el contenedor de la implementación activa. Va UNA sola vez,
    en App.js, al lado del router.

    Las implementaciones inline (react-bootstrap) no tienen Host: se
    renderizan donde las pongas y este componente devuelve null.
*/

export const AppAlertHost = () => {

    const [useTemplateId, setTemplateId] = useState(onReadAlertTemplate);
    const [usePosition, setPosition] = useState(onReadAlertPosition);

    useEffect(() => {

        const onChangeTemplate = (event) => setTemplateId(event.detail?.id);
        const onChangePosition = (event) => setPosition(event.detail?.id);

        window.addEventListener(ALERT_TEMPLATE_EVENT, onChangeTemplate);
        window.addEventListener(ALERT_POSITION_EVENT, onChangePosition);

        return () => {
            window.removeEventListener(ALERT_TEMPLATE_EVENT, onChangeTemplate);
            window.removeEventListener(ALERT_POSITION_EVENT, onChangePosition);
        };

    }, []);

    const TEMPLATE = onResolveAlertTemplate(useTemplateId);

    if (!TEMPLATE.Host) return null;

    const HostComponent = TEMPLATE.Host;

    // 🔥 La key fuerza el remontaje al cambiar librería o posición:
    //    ninguna de las cinco reubica su contenedor en caliente.
    return <HostComponent key={`${TEMPLATE.id}_${usePosition}`} position={usePosition} />;
};

/*
    🔥 API ÚNICA PARA TODA LA APP

    import { notify } from './AppAlertHost';
    notify.success('Guardado', 'El producto se actualizó');
*/
const onNotify = (type) => (title, text, options = {}) => {

    const TEMPLATE = onResolveAlertTemplate(onReadAlertTemplate());

    if (!TEMPLATE.notify) {
        console.warn(`[Alerts] "${TEMPLATE.label}" es inline: usá el componente en el JSX, no notify().`);
        return null;
    }

    return TEMPLATE.notify({ type, title, text, position: onReadAlertPosition(), ...options });
};

export const notify = {
    success: onNotify('success'), error: onNotify('danger'),
    danger: onNotify('danger'), warning: onNotify('warning'),
    info: onNotify('info'), show: (type, title, text, options) => onNotify(type)(title, text, options),
};
